module.exports = __webpack_public_path__ + "static/media/bird-crow1.e81206da.aac";